import React from "react";

const LiveChatSupportPage = () => <div>Live chat support</div>;

export default LiveChatSupportPage;
